import React from "react";
import {
  Box,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";
import { Close as CloseIcon, PhotoCamera as PhotoCameraIcon, Scale as ScaleIcon } from "@mui/icons-material";
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import ReactDOMServer from "react-dom/server";
import moment from "moment/moment";

class DialogDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      item: null,
      isOpen: false,
      sections: [],
      mapData: null,
    };
  }

  open = (item) => {
    const sections = this.buildSections(item);
    const mapData = this.buildMapData(item);
    this.setState({
      item,
      isOpen: true,
      sections,
      mapData,
    });
  };
  close = () => {
    this.setState({
      item: null,
      isOpen: false,
      sections: [],
      mapData: null,
    });
  };

  buildSections = (item) => {
    const sensor = item?.sensor;
    const hasSensorData = Boolean(sensor?.license_plate);

    const getDirection = (val) => {
      const direction = String(val);
      if (direction === "0") return "Попутное";
      if (direction === "1") return "Встречное";
      return "—";
    };
    const getDateTime = (datetime) => {
      if (!datetime || datetime === "0001-01-01T00:00:00Z") return "—";
      const parsed = moment.parseZone(datetime);
      if (!parsed.isValid()) return datetime;
      return parsed.format("DD.MM.YYYY HH:mm:ss");
    };
    const formatCoords = (lat, lon) => {
      const coords = [lat, lon].filter(Boolean);
      return coords.length ? coords.join(", ") : "—";
    };
    const formatSpeed = (value, suffix = "км/ч") => {
      if (value === null || value === undefined || value === "") return "—";
      return `${value} ${suffix}`;
    };

    return [
      {
        title: "Данные с системы весового контроля (СВК)",
        fields: [
          { label: "Дата и время фиксации", value: getDateTime(item?.apvgk?.datetime) },
          { label: "Координаты", value: formatCoords(item?.apvgk?.gps?.lat, item?.apvgk?.gps?.lon) },
        ],
      },
      {
        title: "Данные с комплекса фотовидеофиксации",
        fields: hasSensorData
          ? [
              { label: "Распознанный ГРЗ", value: sensor?.license_plate || "—" },
              { label: "Скорость", value: formatSpeed(sensor?.speed) },
              { label: "Разрешенная скорость", value: formatSpeed(sensor?.speed_limit) },
              { label: "Дата и время фиксации", value: getDateTime(sensor?.datetime) },
              { label: "Наименование комплекса", value: sensor?.vendor || "—" },
              { label: "Серийный номер", value: sensor?.complex_serial || "—" },
              { label: "Направление фиксации", value: getDirection(sensor?.direction) },
              { label: "Координаты", value: formatCoords(sensor?.gps?.lat, sensor?.gps?.lon) },
              { label: "Адрес", value: sensor?.address || "—" },
            ]
          : [],
        emptyMessage: hasSensorData ? null : "Нет данных с комплекса фотовидеофиксации",
      },
    ];
  };
  buildMapData = (item) => {
    const points = [];
    const hasSensorPlate = Boolean(String(item?.sensor?.license_plate || "").trim());
    const parseCoord = (val) => {
      const num = parseFloat(val);
      return Number.isFinite(num) ? num : null;
    };
    const apvgkLat = parseCoord(item?.apvgk?.gps?.lat);
    const apvgkLon = parseCoord(item?.apvgk?.gps?.lon);
    if (apvgkLat !== null && apvgkLon !== null) {
      points.push({
        coords: [apvgkLat, apvgkLon],
        label: "СВК",
        color: "#FF5722",
        kind: "svk",
      });
    }
    if (hasSensorPlate) {
      const sensorLat = parseCoord(item?.sensor?.gps?.lat);
      const sensorLon = parseCoord(item?.sensor?.gps?.lon);
      if (sensorLat !== null && sensorLon !== null) {
        points.push({
          coords: [sensorLat, sensorLon],
          label: "Комплекс",
          color: "#2196F3",
          kind: "complex",
        });
      }
    }
    const fallbackCenter = [55.751244, 37.618423];
    let center = fallbackCenter;
    let bounds = null;
    let zoom = 12;

    if (points.length === 1) {
      center = points[0].coords;
      zoom = 14;
    } else if (points.length > 1) {
      const lats = points.map((p) => p.coords[0]);
      const lons = points.map((p) => p.coords[1]);
      const minLat = Math.min(...lats);
      const maxLat = Math.max(...lats);
      const minLon = Math.min(...lons);
      const maxLon = Math.max(...lons);
      bounds = [
        [minLat, minLon],
        [maxLat, maxLon],
      ];
      center = [(minLat + maxLat) / 2, (minLon + maxLon) / 2];
      zoom = 9;
    }

    return { points, center, zoom, bounds };
  };
  getIcon = (point) => {
    const IconEl = point.kind === "svk" ? ScaleIcon : PhotoCameraIcon;
    const iconMarkup = `
      <div style="
        position: relative;
        width: 44px;
        height: 52px;
        filter: drop-shadow(0 2px 6px rgba(0,0,0,0.25));
      ">
        <svg width="44" height="52" viewBox="0 0 44 52" style="position:absolute; inset:0;">
          <path d="M22 0C11 0 2 9 2 20c0 14 20 32 20 32s20-18 20-32C42 9 33 0 22 0Z" fill="${point.color}" />
          <path d="M22 39C32.4934 39 41 30.4934 41 20C41 9.50659 32.4934 1 22 1C11.5066 1 3 9.50659 3 20C3 30.4934 11.5066 39 22 39Z" fill="white"/>
        </svg>
        <div style="
          position: absolute;
          top: 11px;
          left: 11px;
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: ${point.color};
        ">
          ${ReactDOMServer.renderToString(<IconEl style={{ width: 18, height: 18, color: point.color }} />)}
        </div> 
      </div>
    `;

    return L.divIcon({
      html: iconMarkup,
      className: "",
      iconSize: [44, 52],
      iconAnchor: [22, 50],
      tooltipAnchor: [0, -30],
    });
  };

  render() {
    const { isOpen, sections, mapData } = this.state;

    return (
      <Dialog
        open={isOpen}
        fullWidth
        maxWidth="lg"
        onClose={this.close}
      >
        <DialogTitle sx={{ padding: "16px 20px" }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Подробная информация
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={this.close}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#F7F8FA" }}>
          <Grid container spacing={2}>
            {sections.map((section, sectionIndex) => (
              <Grid item size={12} key={`section-${sectionIndex}`}>
                <Box
                  sx={{
                    borderRadius: 2,
                    border: "1px solid #E0E6F0",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.04)",
                    padding: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
                    {section.title}
                  </Typography>
                  {section.emptyMessage && (
                    <Box
                      sx={{
                        padding: 2,
                        borderRadius: 1,
                        border: "1px dashed #D3DAE6",
                        backgroundColor: "#F4F6FB",
                        color: "#5A6270",
                        fontWeight: 600,
                      }}
                    >
                      {section.emptyMessage}
                    </Box>
                  )}
                  {!section.emptyMessage && (
                    <Grid container spacing={2}>
                      {section.fields.map((field, fieldIndex) => (
                        <Grid item size={12} key={`${section.title}-field-${fieldIndex}`}>
                          <Typography variant="caption" color="textSecondary" sx={{ display: "block" }}>
                            {field.label}
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {field.value}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>
              </Grid>
            ))}

            <Grid item size={12}>
              <Box sx={{
                  borderRadius: 2,
                  border: "1px solid #E0E6F0",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.04)",
                  padding: 2,
                }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>Расположение точек фиксации на карте</Typography>
                <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <ScaleIcon sx={{ color: "#FF5722", fontSize: 22 }} />
                    <Typography sx={{ fontWeight: 600, color: "#FF5722" }}>СВК</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <PhotoCameraIcon sx={{ color: "#2196F3", fontSize: 22 }} />
                    <Typography sx={{ fontWeight: 600, color: "#2196F3" }}>Комплекс</Typography>
                  </Box>
                </Box>
                {mapData?.points?.length ? (
                  <Box sx={{ height: 320, borderRadius: 1, overflow: "hidden" }}>
                    {/*
                      Используем bounds для автоподбора масштаба, чтобы все точки влезли.
                      При одной точке fallback на center/zoom.
                    */}
                    {(() => {
                      const mapProps = mapData.bounds
                        ? { bounds: mapData.bounds, zoom: mapData.zoom }
                        : { center: mapData.center, zoom: mapData.zoom };
                      return (
                        <MapContainer
                          {...mapProps}
                          style={{ height: "100%", width: "100%" }}
                          scrollWheelZoom={false}
                          attributionControl={false}
                          whenCreated={(map) => {
                            if (mapData.bounds) {
                              // Больше отступов, чтобы точки не упирались в края
                              map.fitBounds(mapData.bounds, { padding: [80, 80] });
                            } else {
                              map.setView(mapData.center, mapData.zoom);
                            }
                          }}
                        >
                          <TileLayer
                            attribution=""
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          />
                          {mapData.points.map((point, idx) => (
                            <Marker
                              key={`point-${idx}-${point.label}`}
                              position={point.coords}
                              icon={this.getIcon(point)}
                            >
                              <Tooltip direction="top" offset={[0, -4]} opacity={1}>
                                {`${point.label} (${point.coords[0]}, ${point.coords[1]})`}
                              </Tooltip>
                            </Marker>
                          ))}
                        </MapContainer>
                      );
                    })()}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      padding: 2,
                      borderRadius: 1,
                      border: "1px dashed #D3DAE6",
                      backgroundColor: "#F4F6FB",
                      color: "#5A6270",
                      fontWeight: 600,
                    }}
                  >
                    Нет координат для отображения
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default DialogDetails;
